import { Client } from '@/utils';
import { deptDetail as deptDetailAPI } from '@/api';

const GET_DEPARTMENTLIST = 'deptDetail/GET_DEPARTMENTLIST';


export default {
    state:{
        tableData:{},
    },
    actions:{
        async [GET_DEPARTMENTLIST]({ commit }, { params = {}, frontCode = '' } = {}) {
            commit(GET_DEPARTMENTLIST, await Client.get(deptDetailAPI.getDepartmentList, { params }, frontCode));
        },
    },
    mutations:{
        [GET_DEPARTMENTLIST](state,data) {
            state.tableData = data;
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/deptDetail.js